import { Controller } from 'stimulus'

// One per subsidiary card. Reveals the primary-contact block whenever the company
// is flagged as paying or reporting separately. Runs on connect so resumed/failed
// submissions render with the correct initial state.
export default class extends Controller {
  static targets = ['contact']

  connect() {
    this.toggle()
  }

  toggle() {
    const anyChecked =
      this.element.querySelectorAll('input[type=checkbox][data-flag]:checked')
        .length > 0
    this.contactTarget.style.display = anyChecked ? '' : 'none'
    // Require the contact fields (client-side) only while the block is visible — a
    // hidden required field would break the form's reportValidity() check on submit.
    this.contactTarget
      .querySelectorAll('[data-contact-required]')
      .forEach((field) => {
        field.required = anyChecked
      })
  }
}
